




























import Vue from "vue";
import { PARTNERS } from "@/config";

export default Vue.extend({
  name: "Partnerships",
  data() {
    return {
      partners: PARTNERS
    };
  }
});
